/* eslint-disable react-hooks/exhaustive-deps */
import { ApartmentOutlined, ExclamationCircleOutlined, UnorderedListOutlined, } from '@ant-design/icons';
import { Empty, Input, Modal, Pagination, Select, Tabs } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import IconCameraEmpty from '../../assets/icons/camera-empty.svg';
import * as SERVICE from '../../constants/service.types';
import { clearListAllDeviceByGroup, socketEmitEvent, } from '../../redux/actions';
import CameraSearch from './CameraSearch';
import CreateGroupComponent from './CreateGroup';
import DndCamera from './DndCamera';
import TreeCamera from './TreeCamera/TreeCamera';

const { Option } = Select;
const { confirm } = Modal;
const { TabPane } = Tabs;
let refClear;

const ListCameraComponent = ({
  data,
  selectCamera,
  setSelect,
  handleUpdateCamera,
  handleUpdateStream,
  page,
  total,
  setPage,
  setPageSize,
  pageSize,
  onDeviceByPage,
  setDataSearchCamera,
  nameCameraSearch,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    userId,
    namespace,
    deviceGroup,
    searchDevices,
    totalDevicesGroup,
    updateDeviceGroup,
  } = useSelector((state) => state);
  const [camera, setCamera] = useState(data);
  const [requestId, setRequestId] = useState(new Date().getTime());
  const [cameraGroup1, setCameraGroup1] = useState();
  const [owner, setOwner] = useState(userId);
  const [current, setCurrent] = useState();
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [idParentCameraGroup, setIdParentCameraGroup] = useState(-1);

  const [checkData, setCheckData] = useState(0); // selectedCameraGroupId, = 0 -> all
  const [tabActive, setTabActive] = useState('1');
  const [dataArr, setDataArr] = useState({});

  const [key, setKey] = useState(Math.random());
  const [dataSelectSearch, setDataSelectSearch] = useState('name');
  const [keySearch, setKeySearch] = useState(Math.random());
  const [pageCamera, setPageCamera] = useState(1);
  const [pageSizeCamera, setPageSizeCamera] = useState(10);
  const [searchName, setSearchName] = useState('');
  const [selectGroupId, setSelectGroupId] = useState();
  const [refreshCameraGroupSelect, setRefreshCameraGroupSelect] =
    useState(null);

  useEffect(() => {
    return () => clearTimeout(refClear);
  }, []);

  useEffect(() => {
    if (searchDevices) {
      setCameraGroup1((prev) => ({ ...prev, devices: searchDevices }));
    }
  }, [searchDevices]);

  const getCameraByGroup = (selectGroupId, page, pageSize) => {
    const dataTimeRequest = new Date().getTime();
    setRequestId(dataTimeRequest);
    dispatch(
      socketEmitEvent({
        appServiceType: SERVICE.GET_DEVICE_GROUP_BY_ID,
        requestId: dataTimeRequest,
        body: JSON.stringify({
          page: page,
          size: pageSize,
          namespace,
          deviceGroupId: selectGroupId,
          timeRequest: dataTimeRequest,
        }),
      })
    );
  };

  // Get All devices when update group
  const getAllCameraByGroup = () => {
    if (selectGroupId) {
      const dataTimeRequest = new Date().getTime();
      dispatch(
        socketEmitEvent({
          appServiceType: SERVICE.LIST_DEVICE_BY_DEVICE_GROUP_ID,
          requestId: dataTimeRequest,
          body: JSON.stringify({
            namespace,
            deviceGroupId: selectGroupId,
            timeRequest: dataTimeRequest,
          }),
        })
      );
    }
  };

  useEffect(() => {
    if (updateDeviceGroup) {
      getCameraByGroup(updateDeviceGroup?.id, 0, 10);
    }
  }, [dispatch, namespace, updateDeviceGroup]);

  useEffect(() => {
    if (selectGroupId) {
      getCameraByGroup(selectGroupId, pageCamera - 1, pageSizeCamera);
    }
  }, [pageCamera, pageSizeCamera, selectGroupId]);

  useEffect(() => {
    // update new device group data after update action
    if (deviceGroup?.requestId === requestId && deviceGroup?.deviceGroup) {
      setCameraGroup1(deviceGroup?.deviceGroup);
    }
  }, [deviceGroup]);

  useEffect(() => {
    if (nameCameraSearch) {
      onSearch(nameCameraSearch);
      setKeySearch(Math.random());
    }
  }, [nameCameraSearch]);

  useEffect(() => {
    if (selectCamera) {
      setCurrent(selectCamera);
    }
  }, [selectCamera]);

  const handleRemoveDevice = (name, serial) => {
    let data = {
      serial,
      namespace,
    };
    let dataObj = {
      appServiceType: SERVICE.REMOVE_DEVICE,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    confirm({
      title: t('Remove camera') + ` "${name}"?`,
      icon: <ExclamationCircleOutlined />,
      okText: t('Remove'),
      onOk() {
        return dispatch(socketEmitEvent(dataObj));
      },
      onCancel() {},
    });
  };

  const onChangeCreate = () => {
    setVisibleAdd(true);
    setDataArr(null);
  };

  const onChangeEdit = () => {
    getAllCameraByGroup();
    setVisibleAdd(true);
    setDataArr(cameraGroup1);
  };

  const onChangeDelete = () => {
    let data = {
      namespace,
      id: checkData,
    };
    let dataObj = {
      appServiceType: SERVICE.DELETE_DEVICE_GROUP,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    const groupName = cameraGroup1.name;
    confirm({
      title: t('Remove group') + ` "${groupName}"?`,
      icon: <ExclamationCircleOutlined />,
      okText: t('Remove'),
      onOk() {
        dispatch(socketEmitEvent(dataObj));
        onListDevice();
        setCheckData(0);
        setCameraGroup1(null);
        setKey(Math.random());
      },
      onCancel() {},
    });
  };

  const onChangeSelect = (option) => {
    // TODO refactor logic
    setKeySearch(Math.random());
    if (option.value === 0) {
      setCheckData(0);
      setCameraGroup1(null);
    } else {
      setCheckData(option.value);
      setSelectGroupId(option.id);
      const dataTimeRequest = new Date().getTime();
      setRequestId(dataTimeRequest);
      getCameraByGroup(option.id, 0, 10);
    }
  };

  useEffect(() => {
    if (userId) {
      setOwner(userId);
    }
  }, [userId]);

  useEffect(() => {
    if (data) {
      setCamera(data);
    }
  }, [data]);

  const onCreateGroup = (values, dataList) => {
    let data = {
      namespace,
      name: values.name,
      type: values.type,
      parentDeviceGroupId: idParentCameraGroup ? idParentCameraGroup : -1,
      deviceInfos:
        (dataList &&
          dataList.length > 0 &&
          dataList.map((item, index) => ({
            serial: item.serial,
            indexOf: index + 1,
          }))) ||
        [],
    };
    let dataObj = {
      appServiceType: SERVICE.ADD_DEVICE_GROUP,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    setVisibleAdd(false);
    return dispatch(socketEmitEvent(dataObj));
  };

  const onUpdateGroup = (values, dataList, id) => {
    let data = {
      namespace,
      deviceGroupId: id,
      name: values.name,
      type: values.type,
      deviceInfos:
        (dataList &&
          dataList.length > 0 &&
          dataList.map((item, index) => ({
            serial: item.serial,
            indexOf: index + 1,
          }))) ||
        [],
    };
    let dataObj = {
      appServiceType: SERVICE.UPDATE_DEVICE_GROUP,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    setVisibleAdd(false);
    dispatch(clearListAllDeviceByGroup(null));
    return dispatch(socketEmitEvent(dataObj));
  };

  const onListDevice = () => {
    onDeviceByPage();
    setRefreshCameraGroupSelect(new Date().getTime());
  };

  const onCancelGroupModal = () => {
    setVisibleAdd(false);
    dispatch(clearListAllDeviceByGroup(null));
  };

  const handleSearch = (searchName) => {
    const timeRequest = new Date().getTime();
    setDataSearchCamera(searchName?.trim());
    if (checkData === 0) {
      setPage(1);
    } else {
      setPageCamera(1);
    }
    let data = {
      deviceType: 'camera',
      page: 0,
      size: 10,
      timeRequest,
      namespace,
    };
    if (searchName?.trim()) {
      if (dataSelectSearch === 'name') {
        data.name = searchName?.trim();
      } else {
        data.tags = searchName?.trim();
      }
    }
    let dataObj = {
      appServiceType:
        dataSelectSearch === 'tag' && searchName?.trim()
          ? SERVICE.LIST_DEVICE_BY_TAGS
          : SERVICE.LIST_ALL_DEVICE_BY_PAGE,
      requestId: timeRequest,
      body: JSON.stringify(data),
    };
    dispatch(socketEmitEvent(dataObj));
  };

  const handleSearchCameraByGroup = (name) => {
    const dataTimeRequest = new Date().getTime();
    setRequestId(dataTimeRequest);
    dispatch(
      socketEmitEvent({
        appServiceType: SERVICE.SEARCH_DEVICE_BY_NAME,
        requestId: dataTimeRequest,
        body: JSON.stringify({
          name,
          namespace,
          deviceType: 'camera',
          deviceGroupId: selectGroupId,
          timeRequest: dataTimeRequest,
        }),
      })
    );
  };

  const onSearch = (e) => {
    const { value: name } = e.target;
    setSearchName(name);
    clearTimeout(refClear);
    if (checkData === 0) {
      if (name?.trim()) {
        refClear = setTimeout(() => {
          handleSearch(name);
        }, 2000);
      } else {
        handleSearch(name);
      }
    } else {
      if (name?.trim()) {
        refClear = setTimeout(() => {
          handleSearchCameraByGroup(name?.trim());
        }, 2000);
      } else {
        getCameraByGroup(selectGroupId, 0, 10);
      }
    }
  };

  const onSearchPressEnter = (e) => {
    const { value: name } = e.target;
    setSearchName(name);
    clearTimeout(refClear);
    if (checkData === 0) {
      handleSearch(name);
    } else {
      if (name?.trim()) {
        handleSearchCameraByGroup(name?.trim());
      } else {
        getCameraByGroup(selectGroupId, 0, 10);
      }
    }
  };

  const onPageChange = (newPage, pageSize) => {
    if (checkData === 0) {
      setPage(newPage);
      setPageSize(pageSize);
    } else {
      setPageCamera(newPage);
      setPageSizeCamera(pageSize);
    }
  };

  return (
    <div className="pinned-camera-component" style={{ width: 300 }}>
      <Tabs
        defaultActiveKey={tabActive}
        onChange={(value) => {
          setTabActive(value);
          // reset CameraGroup1 khi tab bằng 2
          if (value === '2') {
            setCheckData(0);
            setCameraGroup1(null);
          }
        }}
      >
        <TabPane
          tab={
            <span>
              <UnorderedListOutlined />
              {t('List')}
            </span>
          }
          key="1"
        ></TabPane>
        <TabPane
          tab={
            <span>
              <ApartmentOutlined />
              {t('Tree')}
            </span>
          }
          key="2"
        />
      </Tabs>

      <div className="camera-tab-content">
        {/* For tab List */}
        {tabActive == 1 && (
          <div>
            <CameraSearch
              value={cameraGroup1}
              onChangeSelect={onChangeSelect}
              refreshCameraGroupSelect={refreshCameraGroupSelect}
              onChangeCreate={onChangeCreate}
              onChangeEdit={onChangeEdit}
              onChangeDelete={onChangeDelete}
              checkData={checkData}
              labelDefault={tabActive === '1' ? 'All camera' : 'All group'}
            />
            <div style={{ display: 'flex', marginBottom: '8px' }}>
              <Select
                value={dataSelectSearch}
                style={{ marginRight: '4px' }}
                onChange={(value) => setDataSelectSearch(value)}
              >
                <Option value="name">
                  <span style={{ textTransform: 'none' }}>{t('Name')}</span>
                </Option>
                <Option value="tag">
                  <span style={{ textTransform: 'none' }}>{t('Tag')}</span>
                </Option>
              </Select>
              <Input
                key={keySearch}
                placeholder={t('Search camera')}
                onChange={onSearch}
                onPressEnter={onSearchPressEnter}
                allowClear
                defaultValue={nameCameraSearch || null}
              />
            </div>

            <div
              className="main-pinned-component"
              style={{
                height: 'calc(100vh - 260px)',
              }}
            >
              <DndCamera
                setSelect={setSelect}
                current={current}
                data={checkData === 0 ? camera : cameraGroup1?.devices}
                owner={owner}
                handleUpdateCamera={handleUpdateCamera}
                handleUpdateStream={handleUpdateStream}
                handleRemoveDevice={handleRemoveDevice}
              />

              {checkData === 0 && camera?.length === 0 && (
                <Empty
                  style={{ margin: 80 }}
                  image={IconCameraEmpty}
                  imageStyle={{
                    height: 60,
                  }}
                  description={<span>{t('No cameras!')}</span>}
                />
              )}
              {checkData !== 0 && cameraGroup1?.devices?.length === 0 && (
                <Empty
                  style={{ margin: 80 }}
                  image={IconCameraEmpty}
                  imageStyle={{
                    height: 60,
                  }}
                  description={<span>{t('No cameras!')}</span>}
                />
              )}
            </div>

            <div className="pagination">
              {(checkData === 0
                ? camera?.length > 0
                : cameraGroup1?.devices?.length > 0 && !searchName) && (
                <Pagination
                  current={checkData === 0 ? page : pageCamera}
                  onChange={onPageChange}
                  total={checkData === 0 ? total : totalDevicesGroup}
                  pageSize={checkData === 0 ? pageSize : pageSizeCamera}
                  showSizeChanger={true}
                  size="small"
                  style={{ display: 'flex', justifyContent: 'center' }}
                />
              )}
            </div>
          </div>
        )}

        {/* For tab Tree */}
        {tabActive == 2 && (
          <TreeCamera
            setSelect={setSelect}
            owner={owner}
            handleUpdateStream={handleUpdateStream}
            handleRemoveDevice={handleRemoveDevice}
            handleUpdateCamera={handleUpdateCamera}
            total={total}
            onCreateGroup={onCreateGroup}
            setVisibleAdd={setVisibleAdd}
            setDataArr={setDataArr}
            setIdParentCameraGroup={setIdParentCameraGroup}
            cameraGroup1={cameraGroup1}
            checkData={checkData}
            current={current?.serial}
          />
        )}
      </div>

      <Modal
        style={{ top: 80 }}
        forceRender
        visible={visibleAdd}
        title={
          dataArr ? (
            <span style={{ textTransform: 'uppercase' }}>
              {t('Update camera group')}
            </span>
          ) : (
            <span style={{ textTransform: 'uppercase' }}>
              {t('Create camera group')}
            </span>
          )
        }
        onCancel={() => onCancelGroupModal()}
        footer={null}
      >
        {visibleAdd && (
          <CreateGroupComponent
            total={total}
            onListDevice={onListDevice}
            dataDevice={dataArr}
            data={camera}
            onCreateGroup={onCreateGroup}
            onUpdateGroup={onUpdateGroup}
          />
        )}
      </Modal>
    </div>
  );
};

export default ListCameraComponent;
